import type { MatchCard, MatchInvite } from "@hub/shared";

/** The viewer's own name as the other parties see it; both parties carry it when the viewer owns them. */
export function viewerName(card: MatchCard): string {
  if (card.roles.viewerOwnsNeeder) return card.needer.ownerName;
  if (card.roles.viewerOwnsHelper) return card.helper.ownerName;
  return "I";
}

function firstName(name: string | null | undefined, fallback: string): string {
  const n = (name ?? "").trim();
  return n ? n.split(/\s+/)[0] : fallback;
}

/** Which side of the match the invited person is on, by name; the needer when unsure. */
export function invitedSide(card: MatchCard, invite: MatchInvite): "needer" | "helper" {
  const name = (invite.name ?? "").trim().toLowerCase();
  if (name && name === card.helper.name.trim().toLowerCase()) return "helper";
  if (invite.email && card.helper.email && invite.email.toLowerCase() === card.helper.email.toLowerCase()) return "helper";
  return "needer";
}

/** The email the viewer sends themselves: who they are introducing and the link to join. */
export function inviteEmail(card: MatchCard, invite: MatchInvite): { subject: string; body: string; mailto: string } {
  const me = viewerName(card);
  const side = invitedSide(card, invite);
  const other = side === "needer" ? card.helper.name : card.needer.name;
  const hello = firstName(invite.name, "there");
  const reason =
    side === "needer"
      ? `you mentioned you were looking for ${card.need.title.toLowerCase()}, and ${other} can help with that (${card.service.title.toLowerCase()}).`
      : `${other} is looking for ${card.need.title.toLowerCase()}, and your ${card.service.title.toLowerCase()} sounds like a fit.`;
  const subject = `An introduction: ${card.needer.name} and ${card.helper.name}`;
  const body = [
    `Hi ${hello},`,
    "",
    `I use Hub to keep track of the people I know and the help they are looking for. I think I can make a useful introduction: ${reason}`,
    "",
    `If you want to be introduced, join Hub with this link and the introduction will be waiting for you:`,
    invite.link,
    "",
    `Sign up with ${invite.email} so it finds you.`,
    "",
    me,
  ].join("\n");
  const mailto = `mailto:${encodeURIComponent(invite.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return { subject, body, mailto };
}
